import { useTranslation } from 'react-i18next';
import { preferenceSlot } from '~/hooks/usePreferenceWriteQueue';
import { useSavedFilterViews } from '~/hooks/useSavedFilterViews';
import type { GetUserPreferencesQuery } from '~/graphql/graphql';
import { savedViewMessages } from '~/utils/savedViewMessages';
import type { BuyListFilterRow } from '~/pages/buy-lists/lib/buyListFilters';
import {
  isMyBuyListFilterData,
  myBuyListRowsToFilterData,
  readMyBuyListFilterRows,
} from '~/pages/buy-lists/lib/buyListFilterStorage';
import type { BuyListSavedViews } from '~/pages/buy-lists/lib/useBuyListSavedViews';

const MY_BUY_LISTS_VIEW = 'MY_BUY_LISTS' as const;
const MY_BUY_LISTS_PERSPECTIVE = 'BUYING' as const;

type Preferences = GetUserPreferencesQuery['userPreferences'] | undefined;

function activeIdOf(preferences: Preferences): string | null {
  return preferences?.myBuyListsActiveFilterId ?? null;
}

function anonymousOf(preferences: Preferences): unknown {
  return preferences?.myBuyListFilter;
}

export function useMyBuyListSavedViews(): BuyListSavedViews {
  const { t } = useTranslation('inventory');

  return useSavedFilterViews<BuyListFilterRow>({
    view: MY_BUY_LISTS_VIEW,
    perspective: MY_BUY_LISTS_PERSPECTIVE,
    slot: preferenceSlot('myBuyLists', MY_BUY_LISTS_PERSPECTIVE),
    isOwnFilterData: isMyBuyListFilterData,
    readRows: readMyBuyListFilterRows,
    rowsToFilterData: myBuyListRowsToFilterData,
    activeIdOf,
    anonymousOf,
    anonymousPreferences: (rows) => ({
      myBuyListFilter: myBuyListRowsToFilterData(rows),
    }),
    messages: savedViewMessages(t, 'inventory.buy_list.filter'),
  });
}
